import React, {useEffect, useState} from 'react'
import {Button} from './Button'

function ContactModalV2({open, onClose}) {
  const [form, setForm] = useState({first: '', last: '', email: '', message: ''})
  const [error, setError] = useState('')
  const [submitted, setSubmitted] = useState(false)

  useEffect(() => {
    if (!open) return undefined
    document.body.style.overflow = 'hidden'
    const onKey = event => {
      if (event.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', onKey)
    return () => {
      document.body.style.overflow = ''
      window.removeEventListener('keydown', onKey)
    }
  }, [open, onClose])

  if (!open) return null

  const update = event => {
    setForm({...form, [event.target.name]: event.target.value})
  }

  const submit = event => {
    event.preventDefault()
    if (!form.first || !form.last || !form.email || !form.message) {
      setError('Please complete every field before submitting.')
      return
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      setError('Please enter a valid email address.')
      return
    }
    setError('')
    setSubmitted(true)
  }

  return (
    <div className="hlm-modal-backdrop" role="presentation" onClick={onClose}>
      <div className="hlm-modal" role="dialog" aria-modal="true" aria-labelledby="contact-modal-title" onClick={event => event.stopPropagation()}>
        <button className="hlm-modal-close" aria-label="Close" onClick={onClose}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true">
            <line x1="6" y1="6" x2="18" y2="18" />
            <line x1="18" y1="6" x2="6" y2="18" />
          </svg>
        </button>
        <h2 id="contact-modal-title" className="hlm-modal-title">
          Contact Us
        </h2>
        <p className="hlm-modal-sub">Fill out the form below and we&rsquo;ll get back to you as soon as possible.</p>
        {submitted ? (
          <div className="hlm-form-success">Thanks — we&rsquo;ll be in touch within 1 business day.</div>
        ) : (
          <form className="hlm-form" onSubmit={submit}>
            {error && <div className="hlm-form-error">{error}</div>}
            <div className="hlm-form-row">
              <div className="hlm-field">
                <label htmlFor="hlm-first">First Name</label>
                <input id="hlm-first" name="first" value={form.first} onChange={update} placeholder="John" />
              </div>
              <div className="hlm-field">
                <label htmlFor="hlm-last">Last Name</label>
                <input id="hlm-last" name="last" value={form.last} onChange={update} placeholder="Doe" />
              </div>
            </div>
            <div className="hlm-field">
              <label htmlFor="hlm-email">Email</label>
              <input id="hlm-email" name="email" type="email" value={form.email} onChange={update} placeholder="john@example.com" />
            </div>
            <div className="hlm-field">
              <label htmlFor="hlm-message">Message</label>
              <textarea id="hlm-message" name="message" value={form.message} onChange={update} placeholder="How can we help you?" rows={5} />
            </div>
            <div className="hlm-form-actions">
              <Button type="submit">Submit</Button>
            </div>
          </form>
        )}
      </div>
    </div>
  )
}

export default ContactModalV2
